import React, { useState } from 'react';
import { Button, Icon } from 'semantic-ui-react';

// Reusable copy-to-clipboard trigger. Shows brief "Copiado" feedback and
// falls back to a hidden-textarea copy when the async Clipboard API isn't
// available (older browsers, insecure contexts).
function CopyButton({ value, label = 'Copiar', size = 'mini' }) {
  const [copied, setCopied] = useState(false);

  const copyWithFallback = () => {
    const textarea = document.createElement('textarea');
    textarea.value = value;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
  };

  const handleCopy = async () => {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(value);
      } else {
        copyWithFallback();
      }
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1500);
    } catch (error) {
      try {
        copyWithFallback();
        setCopied(true);
        window.setTimeout(() => setCopied(false), 1500);
      } catch (fallbackError) {
        console.error('No se pudo copiar al portapapeles:', fallbackError);
      }
    }
  };

  return (
    <Button
      type="button"
      basic
      size={size}
      color={copied ? 'green' : 'violet'}
      onClick={handleCopy}
      aria-label={`${label} ${value}`}
      style={{ minWidth: 96, transition: 'all 0.15s ease' }}
    >
      <Icon name={copied ? 'check' : 'copy outline'} />
      {copied ? 'Copiado' : label}
    </Button>
  );
}

export default CopyButton;
